import * as React from "react";
import * as _ from "lodash";
import * as utils from "../../../common";
import { LegendContents } from "../../Legend";
import {
  PieChart as RePieChart,
  Pie as RePie,
  Sector,
  Cell,
  Tooltip as ReTooltip,
  Text,
  ResponsiveContainer,
  Legend as ReLegend
} from "recharts";
import { Tooltip as TooltipContents } from "../../../common/Tooltip";
import { PercentLabel } from "../../PercentLabel";

const Tooltip: any = ReTooltip;
const PieChart: any = RePieChart;
const Pie: any = RePie;
const Legend: any = ReLegend;

const legendStyle = {
  left: 500,
  top: 0
};

export class SimplePieChart extends React.Component<SimplePieChartProps, any> {
  // We format the data array to display properly inside the pie chart
  formatData(data: IChartData, key: string, groupingKey: string) {
    // Sort data, defaulting to 0
    let sortedData = _.orderBy(data, (entry: any) => entry[key] || 0, ["asc"]);

    // If the number of entries is too large, group the smallest ones
    // into a single 'others' entry
    let offset = sortedData.length - 9;
    if (offset > 0) {
      let othersTotal = sortedData
        .slice(0, offset)
        .reduce((sum: number, entry: IChartData) => sum + entry[key], 0);
      let othersEntry = { [groupingKey]: "Others", [key]: othersTotal };
      sortedData = sortedData.slice(offset, sortedData.length);
      sortedData.unshift(othersEntry);
    }

    // Reorder data to display largest to smallest counter clock wise
    sortedData = _.orderBy(sortedData, [key], ["asc"]);
    return sortedData;
  }

  renderPies() {
    let {
      chartProps: { data: chartData, valueKey, groupingKey }
    } = this.props;
    if (chartData && valueKey) {
      const data = this.formatData(chartData, valueKey, groupingKey);
      const startAngle = 90;
      return (
        <Pie
          data={data}
          dataKey={valueKey}
          startAngle={startAngle}
          endAngle={360 + startAngle}
          labelLine={true}
          minAngle={2}
          label={<PercentLabel />}
        >
          {data.map((entry: any, index: number) => {
            return (
              <Cell
                key={`${entry[groupingKey]}`}
                fill={`#${utils.CHART_COLORS[index % utils.CHART_COLORS.length].toString(16)}`}
              />
            );
          })}
        </Pie>
      );
    }
  }

  render() {
    let {
      chartProps: { data, valueKey, groupingKey }
    } = this.props;

    if (!data || data.length == 0) {
      return <div />;
    } else {
      let pies = this.renderPies();
      return (
        <div className="pie-chart">
          <ResponsiveContainer {...this.props.containerProps}>
            <PieChart margin={{ top: 20, right: 500, left: 0 }}>
              <Tooltip
                content={
                  <TooltipContents
                    valueKey={valueKey}
                    groupingKey={groupingKey}
                  />
                }
              />
              {pies}
              <Legend
                wrapperStyle={legendStyle}
                layout="vertical"
                verticalAlign="middle"
                content={
                  <LegendContents
                    valueKey={valueKey}
                    groupingKey={groupingKey}
                  />
                }
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./client/modules/core/Chart/RadialChart/PieChart/SimplePieChart/index.tsx